import Tooltip from '@mui/material/Tooltip';
import { APP_ENV } from '@modules/consts';
import pkgInfo from '../../package.json';

const AppVersion = () => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    return (
        <p
            style={{
                color: 'rgba(3,3,3,0.3)',
                fontSize: '.65rem',
                paddingBottom: '1vh',
                textAlign: 'center',
            }}
        >
            <Tooltip title={APP_ENV} arrow>
                <span style={{ cursor: 'default' }}>{`v${pkgInfo.version}`}</span>
            </Tooltip>
            <br />
            {`© ${2019}${2019 < currentYear ? `-${currentYear}` : ''} Synergetx`}
        </p>
    );
};

export default AppVersion;
